import * as ko from 'knockout'
import ObservableScratching from '../../../Model/Observables/ObservableScratching'

export class ScratchingsViewModel {
  public availableScratchings: ko.ObservableArray<ObservableScratching>
  public isExpanded: ko.Observable<boolean>

  constructor(params: { availableScratchings: ko.ObservableArray<ObservableScratching> }) {
    this.availableScratchings = params.availableScratchings
    this.isExpanded = ko.observable(false)
  }

  public toggleExpanded() {
    this.isExpanded(!this.isExpanded())
  }
}
